// Angular
import { Inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// Local library
import { AccountFacade } from '@amwager/account/data-access';
import { CommonFacade, ENVIRONMENT, SessionService } from '@amwager/data-access';
import { MatNotificationService } from '@amwager/util';

// Local file
import { FundingFacade } from '../+state';
import { FundingService } from './funding.service';

/** Business logic for the withdraw check-by-email component. */
@Injectable()
export class WithdrawCheckByEmailService {

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly sessionService: SessionService,
    private readonly fundingFacade: FundingFacade,
    private readonly accountFacade: AccountFacade,
    private readonly commonFacade: CommonFacade,
    private readonly matNotificationService: MatNotificationService,
    private readonly fundingService: FundingService,
    @Inject(ENVIRONMENT) private readonly environment: string,
  ) {}

  /** Build the check-by-email form. */
  buildForm(): FormGroup {
    return this.formBuilder.group({
      amount: ['', [Validators.required]]
    });
  }

  /** Fetch the user account and stream the result. */
  loadUserAccount$() {
    this.accountFacade.getUserAccoutAPI();
    return this.accountFacade.isGetUserAccountSuccess$();
  }

  /** The user's full name for the check payee. */
  userFullName(): string {
    return this.sessionService.getUserFName() + ' ' + this.sessionService.getUserLast();
  }

  /** Dispatch the check withdrawal and stream the result. */
  withdraw$(type: string, amount: number) {
    this.fundingFacade.withdrawCheckByEmail(type, amount);
    return this.fundingFacade.isWithdrawCheckByEmailSuccess$();
  }

  /** Flag the app as offline for the given source. */
  setOffline(source: string): void {
    this.commonFacade.setIsConnectedInternet(source, false);
  }

  /** Mark all controls touched to reveal validation messages. */
  markFormGroupTouched(formGroup: FormGroup): void {
    this.fundingService.markFormGroupTouched(formGroup);
  }

  /** Show a single-button alert. */
  showAlert(header: string, message: string): void {
    this.matNotificationService.showAlert(header, message, undefined, undefined, 'Close');
  }

  /** Watch connectivity and report changes back to the caller. */
  checkConnectivity(source: string, onChange: (online: boolean) => void): void {
    this.fundingService.checkConnectivity(this.environment, source, onChange);
  }

}
